module.exports = __webpack_public_path__ + "79873b42b8f68a712c58acaa6ac54ef8.svg";